export function aiSummaryStatusMessage(status, errorCode) {
  if (status === 'budget_blocked') {
    if (errorCode === 'daily_token_cap') {
      return ' AI summary was skipped because the daily token allowance cannot cover this request. It resets at midnight UTC.';
    }
    if (errorCode === 'monthly_budget') {
      return ' AI summary was skipped because the monthly AI budget cannot cover this request.';
    }
    return ' AI summary was skipped because an AI usage limit was reached.';
  }
  return {
    blocked_app_check: ' AI summary was not generated because app verification is unavailable.',
    configuration_error: ' AI summary is not configured; rules-based results are available.',
    schema_rejected: ' AI summary failed its format or evidence checks and was not saved; it will try again after the data changes or tomorrow. Rules-based results are available.',
    skipped_rejected: ' AI summary was not retried because it already failed checks for this data; it will try again after the data changes or tomorrow.',
    error: /credit_balance_exhausted|insufficient_quota/.test(errorCode || '')
      ? ' AI provider rejected the request for billing or quota reasons. Contact your CRM provider; rules-based results are available.'
      : ' AI summary is temporarily unavailable; rules-based results are available.',
  }[status] || '';
}
